@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    @include border-radius-r2;
    border: 1px solid var(--border-soft);
    background-color: var(--surface-default);
  }

  .small {
    padding: 12px;
  }

  .medium {
    padding: 16px;
  }

  .large {
    padding: 20px;
  }
}
